import { faTurnLeft } from '@fortawesome/pro-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Link, LinkComponentProps } from '@tanstack/react-router';
import styles from './NavigateBackButton.module.css';

type NavigateBackButtonPropsType = {
  to: LinkComponentProps['to'];
};

export const NavigateBackButton: React.FC<NavigateBackButtonPropsType> = ({
  to,
}) => {
  return (
    <Link to={to} className={styles.navigateBackButtonRoot}>
      <FontAwesomeIcon icon={faTurnLeft} size="xs" />
    </Link>
  );
};
